import React, { FC } from 'react';

import FullscreenPreloader from '~/components/atoms/FullscreenPreloader';

const LegalLoading: FC = () => <FullscreenPreloader />;

export default LegalLoading;
